/**
 * Created by Darius on 2017.04.02.
 */
import fetch from 'isomorphic-fetch';

const options = {
    credentials: 'same-origin',
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
};

const TemplateServices = {
    getTemplates: () => fetch(`/api/templates/`, options),
    getTemplate: (id) => fetch(`/api/templates/${id}`, options),
    previewTemplate: (id, reporter) => fetch(`/api/templates/${id}?reporter=${reporter}`, options),
    postTemplate: (data) =>
        fetch(`/api/templates/`, Object.assign({}, options, {
            method: 'POST',
            body: JSON.stringify(data)
        })),
    sendTemplate: (data) =>
        fetch(`/api/templates/${data.Id}`, Object.assign({}, options, {
            method: 'POST',
            body: JSON.stringify(data)
        })),
    deleteTemplate: (id) =>
        fetch(`/api/templates/${id}`, Object.assign({}, options, {
            method: 'DELETE'
        }))
};

export default {
    TemplateServices
};